const PNOA_HISTORICO_URL = 'https://www.ign.es/wms/pnoa-historico'

// Newest first, the way the Dutch time travel years are ordered. Each flight becomes a layer of
// its own instead of a sublayer: an orthophoto is opaque and ticking a layer switches all of its
// sublayers on, so a single layer holding all the flights would only ever show the topmost one.
// The service also carries the regional PNOA10 flights and the provisional LIDAR orthophotos, which
// cover single regions and are left out here.
const historicalFlights = [
  { id: 'PNOA2024', title: 'PNOA 2024' },
  { id: 'PNOA2023', title: 'PNOA 2023' },
  { id: 'PNOA2022', title: 'PNOA 2022' },
  { id: 'PNOA2021', title: 'PNOA 2021' },
  { id: 'PNOA2020', title: 'PNOA 2020' },
  { id: 'PNOA2019', title: 'PNOA 2019' },
  { id: 'PNOA2018', title: 'PNOA 2018' },
  { id: 'PNOA2017', title: 'PNOA 2017' },
  { id: 'PNOA2016', title: 'PNOA 2016' },
  { id: 'PNOA2015', title: 'PNOA 2015' },
  { id: 'PNOA2014', title: 'PNOA 2014' },
  { id: 'PNOA2013', title: 'PNOA 2013' },
  { id: 'PNOA2012', title: 'PNOA 2012' },
  { id: 'PNOA2011', title: 'PNOA 2011' },
  { id: 'PNOA2010', title: 'PNOA 2010' },
  { id: 'PNOA2009', title: 'PNOA 2009' },
  { id: 'PNOA2008', title: 'PNOA 2008' },
  { id: 'PNOA2007', title: 'PNOA 2007' },
  { id: 'PNOA2006', title: 'PNOA 2006' },
  { id: 'PNOA2005', title: 'PNOA 2005' },
  { id: 'PNOA2004', title: 'PNOA 2004' },
  { id: 'SIGPAC', title: 'SIGPAC (1997-2003)' },
  { id: 'OLISTAT', title: 'OLISTAT (1997-1998)' },
  { id: 'Nacional_1981-1986', title: 'Nacional (1981-1986)' },
  { id: 'Interministerial_1973-1986', title: 'Interministerial (1973-1986)' },
  { id: 'AMS_1956-1957', title: 'Americano (Serie B, 1956-1957)' }
]

const timeTravelLayers = historicalFlights.map((flight) => ({
  name: flight.title,
  type: 'WMS',
  country: 'TijdreisES',
  url: PNOA_HISTORICO_URL,
  sublayers: [{ id: flight.id, title: flight.title }],
  invertMapTextColour: false
}))

export default [
  {
    name: 'Mapa Base de España',
    type: 'WMS',
    country: 'ES',
    url: 'https://www.ign.es/wms-inspire/ign-base',
    sublayers: [
      { id: 'IGNBaseTodo', title: 'Callejero' },
      { id: 'IGNBaseTodo-nofondo', title: 'Callejero recortado' },
      { id: 'IGNBaseTodo-gris', title: 'Callejero gris' },
      { id: 'IGNBaseOrto', title: 'Callejero para imagen' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Ortoimágenes de España',
    type: 'WMS',
    country: 'ES',
    url: 'https://www.ign.es/wms-inspire/pnoa-ma',
    // The service also offers OI.MosaicElement and fondo, but those are the mosaic index and an
    // opaque backdrop: switch them on beside the imagery and they paint right over it.
    sublayers: [{ id: 'OI.OrthoimageCoverage', title: 'Ortoimagen' }],
    invertMapTextColour: false
  },
  {
    name: 'Modelo Digital del Terreno',
    type: 'WMS',
    country: 'ES',
    url: 'https://servicios.idee.es/wms-inspire/mdt',
    // The grid carries the relief and the other two draw on top of it, so all three together read
    // as one map.
    sublayers: [
      { id: 'EL.ElevationGridCoverage', title: 'Modelo digital del terreno' },
      { id: 'EL.ContourLine', title: 'Curvas de nivel' },
      { id: 'EL.SpotElevation', title: 'Puntos acotados' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Mapa Geológico Continuo (GEODE 50)',
    type: 'WMS',
    country: 'ES',
    url: 'https://mapas.igme.es/gis/services/Cartografia_Geologica/IGME_Geode_50/MapServer/WMSServer',
    // Bedrock first, then the Quaternary cover over it, then the lines and the labels, which is how
    // the sheets themselves are drawn. The service numbers its layers; it also has the sheet index,
    // dips, mineral occurrences and auxiliary lines, which are left out.
    sublayers: [
      { id: '1', title: 'Recintos geología' },
      { id: '3', title: 'Cuaternario' },
      { id: '2', title: 'Contactos' },
      { id: '9', title: 'Rótulos unidades' }
    ],
    invertMapTextColour: true
  },
  {
    name: 'Mapa Hidrogeológico',
    type: 'WMS',
    country: 'ES',
    url: 'https://mapas.igme.es/gis/services/Cartografia_Tematica/IGME_Hidrogeologico_200/MapServer/WMSServer',
    sublayers: [{ id: '0', title: 'Hidrogeología 1:200.000' }],
    invertMapTextColour: true
  },
  {
    name: 'Ocupación del suelo',
    type: 'WMS',
    country: 'ES',
    url: 'https://servicios.idee.es/wms-inspire/ocupacion-suelo',
    // Both cover the whole country, so whichever is listed last is what you see when the layer is
    // switched on as a whole. Land use is the one that says something about what may be in the
    // ground, so it goes second.
    sublayers: [
      { id: 'LC.LandCoverSurfaces', title: 'Cubierta terrestre' },
      { id: 'LU.ExistingLandUse', title: 'Usos del suelo' }
    ],
    invertMapTextColour: true
  },
  {
    // Catalonia only, so it shows nothing over the rest of Spain. The service still answers with
    // its 1.1.1 capabilities, but it serves the 1.3.0 GetMap that OpenLayers sends by default.
    name: 'Servidor Raster ICGC',
    type: 'WMS',
    country: 'ES',
    url: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wms',
    sublayers: [
      { id: 'topografic', title: 'Topogràfic' },
      { id: 'topografic-gris', title: 'Topogràfic gris' },
      { id: 'topografic-mut', title: 'Topogràfic mut' },
      { id: 'topografic-gris-mut', title: 'Topogràfic gris mut' },
      { id: 'simplificat', title: 'Simplificat' },
      { id: 'administratiu', title: 'Administratiu' },
      { id: 'estandard', title: 'Estandard' },
      { id: 'estandard-gris', title: 'Estandard gris' },
      { id: 'orto', title: 'Ortofoto' },
      { id: 'orto-gris', title: 'Ortofoto gris' },
      { id: 'orto-hibrida', title: 'Ortofoto híbrida' },
      { id: 'geologic', title: 'Geològic' }
    ],
    // The topographic sublayers outnumber the orthophotos, and they are the light ones.
    invertMapTextColour: true
  },
  ...timeTravelLayers
]
